export interface NavigationItem {
  path: string
  label: string
  title: string
  icon?: string
}

export interface SocialLink {
  url: string
  label: string
  icon: string
}

export interface AccessibilityControls {
  reducedMotion: boolean
  highContrast: boolean
  largeText: boolean
}

export interface PortfolioState {
  currentPage: string
  sidePanelVisible: boolean
  accessibilityControls: AccessibilityControls
  diagramMode: boolean // Future enhancement
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    path: '/',
    label: 'Home',
    title: 'Lucas Stufflebeam - Principal Software Architect Portfolio',
  },
  { path: '/resume', label: 'Resume', title: 'Lucas Stufflebeam - Resume' },
  { path: '/about', label: 'About', title: 'About Lucas Stufflebeam' },
  { path: '/projects', label: 'Projects', title: 'Portfolio Projects' },
  {
    path: '/case-studies',
    label: 'Case Studies',
    title: 'Technical Case Studies - Lucas Stufflebeam',
  },
]

export const SOCIAL_LINKS: SocialLink[] = [
  {
    url: 'https://linkedin.com/in/lstufflebeam',
    label: 'LinkedIn',
    icon: 'linkedin',
  },
  /*{
    url: 'https://github.com/lucasstufflebeam',
    label: 'GitHub',
    icon: 'github',
  },*/
  { url: 'mailto:lucas@lucasstufflebeam.com', label: 'Contact', icon: 'mail' },
]
